import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { Form } from '_zari/core'

const FechaDocumentoFormGroup = props => {
  const __adminContext = React.useContext(AdminContext)

  const parsedAnio = React.useMemo(() => {
    return __adminContext.anioTrabajo ? parseFloat(__adminContext.anioTrabajo) : null
  }, [__adminContext.anioTrabajo])

  const parsedMes = React.useMemo(() => {
    return __adminContext.mesTrabajo ? parseFloat(__adminContext.mesTrabajo) : null
  }, [__adminContext.mesTrabajo])

  const minDate = React.useMemo(() => {
    let fecha

    if (parsedAnio && parsedMes) {
      fecha = new Date(parsedAnio, parsedMes - 1, 1)
    }

    return fecha
  }, [parsedAnio, parsedMes])

  const maxDate = React.useMemo(() => {
    let fecha

    if (parsedAnio && parsedMes) {
      fecha = new Date(parsedAnio, parsedMes, 0)
    }

    return fecha
  }, [parsedAnio, parsedMes])

  return (
    <Form.InputDate xxxxx={minDate} maxDate={maxDate} showDisabledMonthNavigation {...props} />
  )
}

export default React.memo(FechaDocumentoFormGroup)
